import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { orpc } from '@/api/rpc/client';

/** Mutation errors go to a toast; nothing here depends on the component. */
function showError(error: Error): void {
  toast.error(error.message);
}

/** Create / update / delete for upload rules, each refreshing the list. */
export function useUploadRuleMutations() {
  const queryClient = useQueryClient();
  function refresh(): Promise<void> {
    return queryClient.invalidateQueries({
      queryKey: orpc.pricing.uploadRules.list.key(),
    });
  }
  const create = useMutation({
    ...orpc.pricing.uploadRules.create.mutationOptions(),
    onSuccess: refresh,
    onError: showError,
  });
  const update = useMutation({
    ...orpc.pricing.uploadRules.update.mutationOptions(),
    onSuccess: refresh,
    onError: showError,
  });
  const remove = useMutation({
    ...orpc.pricing.uploadRules.delete.mutationOptions(),
    onSuccess: refresh,
    onError: showError,
  });
  return { create, update, remove };
}
